import { useState } from 'react';
import { IoCloseCircleOutline, IoEyeOutline, IoEyeOffOutline } from 'react-icons/io5';

interface ModalInvestidorProps {
    isOpen: boolean;
    onClose: () => void;
    documentoUrl: string;
}

export default function ModalInvestidor({ isOpen, onClose, documentoUrl }: ModalInvestidorProps) {
    const [senha, setSenha] = useState('');
    const [erro, setErro] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setErro('');
        setLoading(true);

        try {
            const response = await fetch('https://app.chbrental.com.br/api/usuarios/investidores', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ senha: senha })
            });

            if (response.ok) {
                // Sucesso - abre o documento em nova aba
                window.open(documentoUrl, '_blank');
                // Limpa e fecha o modal
                setSenha('');
                onClose();
            } else if (response.status === 401 || response.status === 403) {
                setErro('Senha incorreta. Tente novamente.');
            } else {
                setErro('Erro ao validar senha. Tente novamente.');
            }
        } catch (error) {
            setErro('Erro ao validar senha. Tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setSenha('');
        setErro('');
        onClose();
    };

    return (
        <div className="fixed inset-0 z-[70] bg-black bg-opacity-75 flex items-center justify-center p-5" onClick={handleClose}>
            <div className="bg-white rounded-xl max-w-md w-full p-8" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-bold text-black">Área do Investidor</h2>
                    <IoCloseCircleOutline
                        className="cursor-pointer text-2xl text-gray-600 hover:text-black transition-colors"
                        onClick={handleClose}
                    />
                </div>

                {/* Description */}
                <p className="text-gray-600 mb-6">
                    Digite sua senha para acessar o documento
                </p>

                {/* Form */}
                <form onSubmit={handleSubmit}>
                    <div className="mb-6">
                        <label className="block text-black font-medium mb-2">
                            Senha
                        </label>
                        <div className="relative">
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="Digite sua senha"
                                value={senha}
                                onChange={(e) => setSenha(e.target.value)}
                                className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-700 focus:border-transparent"
                                required
                                disabled={loading}
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-600 hover:text-black transition-colors"
                                disabled={loading}
                            >
                                {showPassword ? (
                                    <IoEyeOffOutline className="text-xl" />
                                ) : (
                                    <IoEyeOutline className="text-xl" />
                                )}
                            </button>
                        </div>
                    </div>

                    {/* Error Message */}
                    {erro && (
                        <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                            {erro}
                        </div>
                    )}

                    {/* Submit Button */}
                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-blue-700 text-white font-medium py-3 rounded-lg hover:bg-blue-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {loading ? 'Validando...' : 'Entrar'}
                    </button>
                </form>
            </div>
        </div>
    );
}
